import React from 'react'

const GetDate = ({date, className}) => {
    const time  = new Date(date).toLocaleDateString("en-GB",{year:"2-digit",month:"2-digit", day:"2-digit"}).replace(/\//g, '.')
    return (
        <time className={`text-red font-display uppercase text-base tracking-wider block ${className ? className : ""}`}>{time}</time>
    )
}

export default GetDate